import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, input, output } from '@angular/core';
import { MatNavList } from '@angular/material/list';
import { SelectedMenuGroup } from '@core/menu/shared/menu-group/menu-group.component';
import { MenuGroupWithMenuItems } from '@core/menu/store/selectors';
import { MenuItemDto } from '@core/services/api-clients';
import { NoEventWidgetDirective } from '@core/widgets/directives/no-event-widget.directive';
import { WidgetDirective } from '@core/widgets/directives/widget.directive';
import { IScriptRunnerService, SCRIPT_RUNNER_SERVICE } from '@core/widgets/models/iscript-runner.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuGroupComponent } from '../../shared/menu-group/menu-group.component';

@Component({
  selector: 'app-main-menu-navigation',
  templateUrl: './main-menu-navigation.component.html',
  styleUrls: ['./main-menu-navigation.component.scss'],
  providers: [
    {
      provide: WidgetDirective,
      useExisting: forwardRef(() => MainMenuNavigationComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatNavList, MenuGroupComponent],
})
export class MainMenuNavigationComponent extends NoEventWidgetDirective {
  @Input() set menuAreaId(menuAreaId: string) {
    if (menuAreaId) {
      this.loaded$.next(true);
    }
  }
  readonly menuGroups = input<MenuGroupWithMenuItems[]>([]);
  readonly specialMenuGroups = input<MenuGroupWithMenuItems[]>([]);
  readonly selectedMenuGroupId = input<string>(undefined);
  readonly selectedMenuItemId = input<string>(undefined);

  readonly isWide = input<boolean>(false);
  readonly isAddFavoriteEnabled = input<boolean>(false);
  readonly isPopupEnabled = input<boolean>(false);
  readonly favorites = input<{
    [id: string]: boolean;
  }>({});

  readonly menuGroupClick = output<SelectedMenuGroup>();
  readonly menuItemClick = output<MenuItemDto>();
  readonly menuItemAddedToFavorite = output<MenuItemDto>();
  readonly menuItemRemovedFromFavorite = output<MenuItemDto>();

  private loaded$ = new BehaviorSubject<boolean>(false);

  constructor() {
    const parentWidget = inject(WidgetDirective, { optional: true, skipSelf: true });
    const scriptRunnerService = inject<IScriptRunnerService>(SCRIPT_RUNNER_SERVICE);

    super(parentWidget, scriptRunnerService);
  }

  protected isWidgetInitiated(): Observable<boolean> {
    return this.loaded$.asObservable().pipe(filter((x) => !!x));
  }
}
